// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-lcgl-hjfp-index-main_right_content-11UIZ","table":"components-lcgl-hjfp-index-table-3XgQU","tablecell-p-text":"components-lcgl-hjfp-index-tablecell-p-text-2FYsU","bottom-description":"components-lcgl-hjfp-index-bottom-description-W9iKL"};


//////////////////
// WEBPACK FOOTER
// ./components/lcgl/hjfp/index.css
// module id = 815
// module chunks = 0